<template>
  <div>
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <div v-if="!loading">
      <div v-if="category">
        <div class="flex items-center space-x-2">
          <router-link
            :to="{
              name: 'productCategoriesIndex',
            }"
            class="fill-current button-interactive"
          >
            <arrow-icon class="w-4 rotate-90"></arrow-icon>
          </router-link>
        </div>

        <div class="card mt-2">
          <div class="flex justify-between items-center">
            <p class="font-medium">ID: #{{ category.id }}</p>

            <div class="flex space-x-4 items-center">
              <router-link
                v-if="hasPermission('edit_product_categories')"
                :to="{
                  name: 'productCategoriesEditForm',
                  params: { id: category.id },
                }"
              >
                <edit-button />
              </router-link>

              <delete-button
                v-if="hasPermission('delete_product_categories')"
                class="delete-icon-button"
                @click.prevent="openDeleteModal()"
              />
            </div>
          </div>

          <div class="div-line"></div>

          <div class="mt-2 text-sm">
            <p class="font-medium">Nombre</p>
            <p>{{ category.name }}</p>
          </div>

          <div class="mt-2 text-sm">
            <p class="font-medium">Fecha de creación</p>
            <p>{{ formatDatetime(category.created_at) }}</p>
          </div>

          <div class="mt-2 text-sm">
            <p class="font-medium">Fecha de última actualización</p>
            <p>{{ formatDatetime(category.updated_at) }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import { formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Product Category Detail",

  data() {
    return {
      category: null,
      loading: false,
      loadingDelete: false,
    };
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setStoreSelectedTab", "productCategories");

    this.loadCategory();
  },

  methods: {
    formatDatetime,

    async loadCategory() {
      this.loading = true;

      try {
        this.category = await api.productCategories.getById(
          this.$route.params.id
        );
        this.$store.commit('setBreadcrumbLabel', {
          routeName: 'productCategoriesDetail',
          label: this.category.name,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: "productCategoriesIndex" });
      }

      this.loading = false;
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.productCategories.delete(this.category.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.$router.push({ name: "productCategoriesIndex" });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>